<section class="box-credit-code">
    <navaar-container-scroll
        class="list-categories"
        [showHeader]="true"
        [title]="'ثبت کد اشتراک، اعتبار یا کتاب صوتی'"
        [show]="true"
        [isPlayAnimation]="false"
        [showIcon]="true"
        [isFixedContainer]="true"
    >
        <div class="inner-contaienr-main-credit-code">
            <div class="credit-code">
                <div class="header-credit-code">
                    <p>
                        در صورتی که به هر طریق، کد تخفیف، اشتراک، اعتبار یا کد مربوط به یک
                        کتاب صوتی دریافت کرده‌اید، می‌توانید با ورود و ثبت آن، از مزایای آن
                        کد بهره‌مند شوید
                    </p>
                </div>
                <div class="form-container">
                    <div class="form-row">
                        <div class="form-group">
                            <input
                                (keydown.enter)="sendCreditCode()"
                                type="text"
                                (focus)="onFocusEvent($event)"
                                [(ngModel)]="creditCode"
                                placeholder="کد اشتراک، اعتبار یا کتاب صوتی"
                            >
                        </div>
                    </div>
                </div>
                <div class="footer-credit-code">
                    <navaar-button
                        [type-button]="'button'"
                        [color-name]="'blue'"
                        [disabled]="(creditCode.length === 0) || isSubmit"
                        (onClick)="isLogin ? sendCreditCode() : device.goTologinPageNative()"
                        [isShowLoader]="isSubmit"
                    >
                        <p [textContent]="isLogin ?'ثبت کد': 'ورود و ثبت کد'"></p>
                    </navaar-button>
                </div>
            </div>
        </div>
    </navaar-container-scroll>
</section>
